module.exports = __webpack_public_path__ + "img/logo_ame.def58541.svg";